<template>
    <div class="tabs-layout">
        <md-tabs @md-changed="changeTab" md-active-tab="tab-intervention">
            <md-tab :id="tabs[0].id" :md-label="tabs[0].label">
                <tab-intervention :interventionId="interventionId" :active="tabs[0].active"></tab-intervention>
            </md-tab>
            <md-tab :id="tabs[1].id" :md-label="tabs[1].label">
                <tab-contract :interventionId="interventionId" :active="tabs[1].active"></tab-contract>
            </md-tab>
            <md-tab :id="tabs[2].id" :md-label="tabs[2].label">
                <tab-site :interventionId="interventionId" :active="tabs[2].active"></tab-site>
            </md-tab>
            <md-tab :id="tabs[3].id" :md-label="tabs[3].label">
                <tab-client :interventionId="interventionId" :active="tabs[3].active"></tab-client>
            </md-tab>
        </md-tabs>
    </div>
</template>

<script>
import TabIntervention from "@/pages/Planning/Calendar/components/calendar/modal-tabs/TabIntervention";
import TabContract from "@/pages/Planning/Calendar/components/calendar/modal-tabs/TabContract";
import TabSite from "@/pages/Planning/Calendar/components/calendar/modal-tabs/TabSite";
import TabClient from "@/pages/Planning/Calendar/components/calendar/modal-tabs/TabClient";
export default {
    name: "CalendarModalIntervention",
    components: {
        TabIntervention, TabContract, TabSite, TabClient
    },
    props: {
        interventionId: Number
    },
    data() {
        return {
            tabs: [
                { id: 'tab-intervention', label: 'Intervention', active: true },
                { id: 'tab-contract', label: 'Contrat', active: false },
                { id: 'tab-site', label: 'Site', active: false },
                { id: 'tab-client', label: 'Client', active: false },
            ]
        }
    },
    methods: {
        changeTab(id = 'tab-intervention') {
            this.tabs.map(tab => tab.active = false)
            let activeTab = this.tabs.find(tab => tab.id === id)
            activeTab.active = true
        },
    },
}
</script>

<style scoped>

</style>
